import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface AlertIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Alert icon using SF Pro font symbol (􀁡)
 *
 * This icon represents error/alert/warning states in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <AlertIcon />
 * <AlertIcon size={12} weight="bold" className="text-brand-red" />
 * ```
 */
export const AlertIcon = React.forwardRef<HTMLSpanElement, AlertIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀁡" {...props} />
  }
)

AlertIcon.displayName = "AlertIcon"
